// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#focus--UGlAI:focus {
  outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
  outline-offset: var(--bo-ui-focus-outline-offset, 2px);
  border-radius: 0.25rem;
}
@supports selector(:focus-visible) {
  #focus--UGlAI:focus {
    outline: none;
    outline-offset: 0;
    border-radius: 0.25rem;
  }
  #focus--UGlAI:focus-visible {
    outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
    outline-offset: var(--bo-ui-focus-outline-offset, 2px);
    border-radius: 0.25rem;
  }
}
#focus-within--NahNR:focus-within {
  outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
  outline-offset: 0px;
  border-radius: 0.25rem;
}
#barOnBottom--Jtm17 {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: #00217D;
  height: 6px;
  border-radius: 4px 4px 0px 0px;
}
.navButton--qaytb {
  position: relative;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.navButton--qaytb:last-child {
  margin-right: 0;
}
.navButton--qaytb:hover::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: #00217D;
  height: 6px;
  border-radius: 4px 4px 0px 0px;
}
.navButton--qaytb.active--pPZkQ::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: #00217D;
  height: 6px;
  border-radius: 4px 4px 0px 0px;
}
.navButton--qaytb button {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.navButton--qaytb button:focus {
  outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
  outline-offset: var(--bo-ui-focus-outline-offset, 2px);
  border-radius: 0.25rem;
}
@supports selector(:focus-visible) {
  .navButton--qaytb button:focus {
    outline: none;
    outline-offset: 0;
    border-radius: 0.25rem;
  }
  .navButton--qaytb button:focus-visible {
    outline: var(--bo-ui-focus-outline, 4px solid #193DA1);
    outline-offset: var(--bo-ui-focus-outline-offset, 2px);
    border-radius: 0.25rem;
  }
}
.navButton--qaytb button span {
  margin-top: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: #1A202C;
  line-height: 1.125rem;
}
.navButton--qaytb button:hover {
  text-decoration: none;
}
.navButton--qaytb button svg {
  color: #1A202C;
}
.navbarIcon--ObZx6 {
  width: 18px;
  height: 18px;
}
.accountIcon--vm31g {
  stroke: white;
  width: 20px;
  height: 20px;
}
.basketCounter--SbQHh {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 10px;
  right: 8px;
  width: 16px;
  height: 16px;
  font-size: 0.75rem;
  pointer-events: none;
  background: #00217D;
  color: #FFF;
  border-radius: 100%;
  font-weight: 500;
}
.menu--AFm5T {
  padding: 0 1rem;
}
.tooltip--lZcCG {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  position: absolute;
  width: 337px;
  height: 173px;
  bottom: -178px;
  right: -90%;
  background: white;
  box-shadow: 0px 2px 10px #e8e8e8;
  border-radius: 4px;
  z-index: -1;
  padding: 1rem;
  font-size: 1rem;
  color: #1A202C;
  justify-content: center;
  cursor: auto;
}
.tooltip--lZcCG a,
.tooltip--lZcCG button {
  color: inherit;
}
.tooltip--lZcCG a:hover,
.tooltip--lZcCG button:hover {
  text-decoration: underline;
}
.menuItem--nlitm {
  flex-direction: row;
}
.menuItem--nlitm p {
  padding-top: 4px;
}
.newMenuItem--XCvFs {
  flex-direction: row;
  justify-content: space-between;
}
.newMenuItem--XCvFs p {
  padding-top: 4px;
}
.newAccountButton--yyuPe {
  flex-direction: row;
  justify-content: left !important;
  padding: 0 0.75rem;
  background: #193DA1;
  color: white;
  margin: 13px 0;
  text-align: left;
}
.newAccountButton--yyuPe svg {
  stroke: white;
  height: 30px !important;
}
.menu--AFm5T {
  padding: 0 1rem;
}
.headerButton--uXF3D {
  flex-direction: column;
  padding: 0 0.75rem;
  margin: 0 0.25rem;
  white-space: nowrap;
}
.accountButton--YFkD4 {
  flex-direction: row;
  justify-content: left !important;
  padding: 0 0.75rem;
  background: #193DA1;
  color: white;
  margin: 13px 0;
  text-align: left;
}
.accountButton--YFkD4 svg {
  stroke: white;
  height: 30px !important;
}
.platformGuideIcon--eGfMd {
  padding-left: 8px;
}
.platformGuideIcon--eGfMd svg {
  height: 14px;
  width: 14px;
  display: inherit;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@boclips-ui/styles/src/focus.less","webpack://./src/components/navButtons/style.module.less"],"names":[],"mappings":"AAIE;EACE,sDAAA;EACA,sDAAA;EACA,sBAAA;ACHJ;ADUE;EACE;IACE,aAAA;IACA,iBAAA;IACA,sBAAA;ECRJ;EDUE;IACE,sDAAA;IACA,sDAAA;IACA,sBAAA;ECRJ;AACF;ADaE;EACE,sDAAA;EACA,mBAAA;EACA,sBAAA;ACXJ;AAlBA;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,8BAAA;AAoBF;AAhBE;EAAA,kBAAA;EAAA,mBAAA;EAAA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA;AAHA;AAKA;EACE,eAAA;AAmBJ;AAfI;EArBF,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,8BAAA;AAuCF;AAnBI;EA3BF,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,8BAAA;AAiDF;AA9CA;EAuBI,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AA0BJ;AD/DE;EACE,sDAAA;EACA,sDAAA;EACA,sBAAA;ACiEJ;AD1DE;EACE;IACE,aAAA;IACA,iBAAA;IACA,sBAAA;EC4DJ;ED1DE;IACE,sDAAA;IACA,sDAAA;IACA,sBAAA;EC4DJ;AACF;AAvCM;EAAA,mBAAA;EAAA,kBAAA;EAAA,gBAAA;EACA,cAAA;EACA;AAFA;AAKF;EACE,qBAAA;AAyCN;AA9EA;EAyCM,cAAA;AAwCN;AAnCA;EACE,WAAA;EACA,YAAA;AAqCF;AAlCA;EACE,aAAA;EACA,WAAA;EACA,YAAA;AAoCF;AAjCA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAmCF;AAhCA;EACE,eAAA;AAkCF;AA/BA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;AAiCF;AAnDA;;EAqBI,cAAA;AAkCJ;AAhCI;;EACE,0BAAA;AAmCN;AA9BA;EACE,mBAAA;AAgCF;AAjCA;EAII,gBAAA;AAgCJ;AA5BA;EACE,mBAAA;EACA,8BAAA;AA8BF;AAhCA;EAII,gBAAA;AA+BJ;AA3BA;EACE,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AA6BF;AApCA;EAUI,aAAA;EACA,uBAAA;AA6BJ;AAzBA;EACE,eAAA;AA2BF;AAxBA;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AA0BF;AAvBA;EACE,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAyBF;AAhCA;EAUI,aAAA;EACA,uBAAA;AAyBJ;AArBA;EACE,iBAAA;AAuBF;AAxBA;EAII,YAAA;EACA,WAAA;EACA,gBAAA;AAuBJ","sourcesContent":["@import './vars';\n\n#focus {\n  // For any browser that doesn't focus-visible (Safari)\n  &:focus {\n    outline: @focus-outline;\n    outline-offset: @focus-outline-offset;\n    border-radius: .25rem;\n  }\n\n  // For browsers that do support focus-visible:\n  // - turn off focus styles\n  // - apply styles only to focus-visible\n  // https://www.tpgi.com/focus-visible-and-backwards-compatibility/\n  @supports selector(:focus-visible) {\n    &:focus {\n      outline: none;\n      outline-offset: 0;\n      border-radius: .25rem;\n    }\n    &:focus-visible {\n      outline: @focus-outline;\n      outline-offset: @focus-outline-offset;\n      border-radius: .25rem;\n    }\n  }\n}\n\n#focus-within{\n  &:focus-within {\n    outline: @focus-outline;\n    outline-offset: 0px;\n    border-radius: .25rem;\n  }\n}\n","@import '~@boclips-ui/styles/src/colors';\n@import '~@boclips-ui/styles/src/focus';\n\n#barOnBottom {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  background-color: @blue-800;\n  height: 6px;\n  border-radius: 4px 4px 0px 0px;\n}\n\n.navButton {\n  @apply items-center justify-center relative;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  &:hover {\n    &::after {\n      #barOnBottom();\n    }\n  }\n\n  &.active {\n    &::after {\n      #barOnBottom();\n    }\n  }\n\n  button {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    #focus();\n\n    span {\n      @apply text-xxs mt-1 font-medium;\n      color: @gray-900;\n      line-height: 1.125rem;\n    }\n\n    &:hover {\n      text-decoration: none;\n    }\n\n    svg {\n      color: @gray-900;\n    }\n  }\n}\n\n.navbarIcon {\n  width: 18px;\n  height: 18px;\n}\n\n.accountIcon {\n  stroke: white;\n  width: 20px;\n  height: 20px;\n}\n\n.basketCounter {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 10px;\n  right: 8px;\n  width: 16px;\n  height: 16px;\n  font-size: 0.75rem;\n  pointer-events: none;\n  background: @blue-800;\n  color: @white;\n  border-radius: 100%;\n  font-weight: 500;\n}\n\n.menu {\n  padding: 0 1rem;\n\n}\n.tooltip {\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: center;\n  position: absolute;\n  width: 337px;\n  height: 173px;\n  bottom: -178px;\n  right: -90%;\n  background: white;\n  box-shadow: 0px 2px 10px #e8e8e8;\n  border-radius: 4px;\n  z-index: -1;\n  padding: 1rem;\n  font-size: 1rem;\n  color: @gray-900;\n  justify-content: center;\n  cursor: auto;\n  a,\n  button {\n    color: inherit;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.menuItem {\n  flex-direction: row;\n\n  p {\n    padding-top: 4px;\n  }\n}\n\n.newMenuItem {\n  flex-direction: row;\n  justify-content: space-between;\n  p {\n    padding-top: 4px;\n  }\n}\n\n.newAccountButton {\n  flex-direction: row;\n  justify-content: left !important;\n  padding: 0 0.75rem;\n  background: @blue-700;\n  color: white;\n  margin: 13px 0;\n  text-align: left;\n\n  svg {\n    stroke: white;\n    height: 30px !important;\n  }\n}\n\n.menu {\n  padding: 0 1rem;\n}\n\n.headerButton {\n  flex-direction: column;\n  padding: 0 0.75rem;\n  margin: 0 0.25rem;\n  white-space: nowrap;\n}\n\n.accountButton {\n  flex-direction: row;\n  justify-content: left !important;\n  padding: 0 0.75rem;\n  background: @blue-700;\n  color: white;\n  margin: 13px 0;\n  text-align: left;\n\n  svg {\n    stroke: white;\n    height: 30px !important;\n  }\n}\n\n.platformGuideIcon {\n  padding-left: 8px;\n\n  svg {\n    height: 14px;\n    width: 14px;\n    display: inherit;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"focus": `focus--UGlAI`,
	"focus-within": `focus-within--NahNR`,
	"barOnBottom": `barOnBottom--Jtm17`,
	"navButton": `navButton--qaytb`,
	"active": `active--pPZkQ`,
	"navbarIcon": `navbarIcon--ObZx6`,
	"accountIcon": `accountIcon--vm31g`,
	"basketCounter": `basketCounter--SbQHh`,
	"menu": `menu--AFm5T`,
	"tooltip": `tooltip--lZcCG`,
	"menuItem": `menuItem--nlitm`,
	"newMenuItem": `newMenuItem--XCvFs`,
	"newAccountButton": `newAccountButton--yyuPe`,
	"headerButton": `headerButton--uXF3D`,
	"accountButton": `accountButton--YFkD4`,
	"platformGuideIcon": `platformGuideIcon--eGfMd`
};
export default ___CSS_LOADER_EXPORT___;
